import React from 'react';
import { Redirect } from 'react-router';
import {baseUrl} from '../shared/baseUrl';
import {Button,Badge} from 'reactstrap';

class Ranking extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            rankListRecord:null,
            rankListVerified:null,

            // Badge Text
            recordCountText: "Top 10",
            verifyCountText: "Top 10",
        }
    }

    componentDidMount = () =>{
        if(!this.props.user.isAuthenticated){
            return(
                <Redirect to='/'/>
            );
        }
        else{
            this.getRankByRecord(10);
            this.getRankByVerify(10);
        }
    }

    getRankByRecord = (count) =>{
        const bearer = 'Bearer ' + localStorage.getItem('token');
        return fetch(baseUrl+'ranks/record/'+count,{
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                'Authorization': bearer
              },
            credentials: 'same-origin'
        })
        .then(response =>{
            if(response.ok){
                // console.log("returned  response is a success");
                // console.log(response);
                return response;
            }
            else{
                var error = new Error("Response failed!!");
                error.response = response;
                // console.log(response);
                throw error;
            }
        },(err)=>{
            var errmess = new Error(err.message+"hulalalala")
            throw errmess;
        })
        .then(response=>{
            // console.log("Inside Reponse\n",response)//
            return response.json()
        })
        .then((users)=>{
            console.log(users)
            this.setState({
                rankListRecord:users,
                recordCountText:"Top "+count
            })
        })
        .catch(err=>console.log(err));
    }

    getRankByVerify = (count) =>{
        const bearer = 'Bearer ' + localStorage.getItem('token');
        return fetch(baseUrl+'ranks/verified/'+count,{
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                'Authorization': bearer
              },
            credentials: 'same-origin'
        })
        .then(response =>{
            if(response.ok){
                // console.log("returned  response is a success");
                // console.log(response);
                return response;
            }
            else{
                var error = new Error("Response failed!!");
                error.response = response;
                // console.log(response);
                throw error;
            }
        },(err)=>{
            var errmess = new Error(err.message+"hulalalala")
            throw errmess;
        })
        .then(response=>{
            // console.log("Inside Reponse\n",response)//
            return response.json()
        })
        .then((users)=>{
            console.log(users)
            this.setState({
                rankListVerified:users,
                verifyCountText:"Top "+count
            })
        })
        .catch(err=>console.log(err));
    }

    render(){
        if(!this.props.user.isAuthenticated){
            return(
                <Redirect to='/'/>
            );
        }
        if(this.state.rankListRecord!==null){
            var rank = 1;
            var rankRecorded = this.state.rankListRecord.map((user)=>{
                return(
                    <div className="mt-2 pl-2 pt-2 row">
                        <div className="col-2">
                            <h6>
                                <h5><Badge color="primary">{rank++}</Badge></h5>
                            </h6>
                        </div>
                        {/* {
                            localStorage.getItem('username')===user.username?
                            <div className="col-7 md-1">
                                <h5><Badge color="danger">{user.name}</Badge></h5>    
                            </div>
                            :
                            <div className="col-7 mt-1">
                                <h6>{user.name}</h6>
                            </div>
                        } */}
                        <div className="col-7 mt-1">
                            <h6>{user.name}</h6>
                        </div>
                        <div className="col-2 mr-2">
                            <h5><Badge color="success">{user.recorded}</Badge></h5>
                        </div>
                    </div>
                );
            });
        }

        if(this.state.rankListVerified!==null){
            var rank = 1;
            var rankVerified = this.state.rankListVerified.map((user)=>{
                return(
                    <div className="mt-2 pl-2 pt-2 row">
                        <div className="col-2">
                            <h6>
                                <h5><Badge color="primary">{rank++}</Badge></h5>
                            </h6>
                        </div>
                        {/* {
                            localStorage.getItem('username')===user.username?
                            <div className="col-7 md-1">
                                <h5><Badge color="danger">{user.name}</Badge></h5>    
                            </div>
                            :
                            <div className="col-7 mt-1">
                                <h6>{user.name}</h6>
                            </div>
                        } */}
                        <div className="col-7 mt-1">
                            <h6>{user.name}</h6>
                        </div>
                        <div className="col-2 mr-2">
                            <h5><Badge color="success">{user.verified}</Badge></h5>
                        </div>
                    </div>
                );
            });
        }

        return(
            <div className="container mt-2">
                <div>
                    <h4><Badge color="warning">Record Rank: {this.state.recordCountText}</Badge></h4>
                    <div className="row m-auto">
                        <div >
                            <Button 
                                size="sm"
                                onClick={()=>this.getRankByRecord(10)}>
                                Top 10</Button>
                        </div>
                        <div >
                            <Button 
                                className="ml-2"
                                size="sm"
                                onClick={()=>this.getRankByRecord(50)}>
                                Top 50</Button>
                        </div>
                        <div >
                            <Button 
                                className="ml-2"
                                size="sm"
                                onClick={()=>this.getRankByRecord(100)}>
                                Top 100</Button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2">
                        <small><Badge>Rank</Badge></small>
                    </div>
                    <div className="col-7">
                        <small><Badge>Name</Badge></small>
                    </div>
                    <div className="col-2">
                        <small><Badge>Recorded</Badge></small>
                    </div>
                </div>
                <div className="activeUserList">
                    {rankRecorded}
                </div>

                <div className="mt-2">
                    <h4><Badge color="warning">Verify Rank: {this.state.verifyCountText}</Badge></h4>
                    <div className="row m-auto">
                        <div >
                            <Button 
                                size="sm"
                                onClick={()=>this.getRankByVerify(10)}>
                                Top 10</Button>
                        </div>
                        <div >
                            <Button 
                                className="ml-2"
                                size="sm"
                                onClick={()=>this.getRankByVerify(50)}>
                                Top 50</Button>
                        </div>
                        <div >
                            <Button 
                                className="ml-2"
                                size="sm"
                                onClick={()=>this.getRankByVerify(100)}>
                                Top 100</Button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2">
                        <small><Badge>Rank</Badge></small>
                    </div>
                    <div className="col-7">
                        <small><Badge>Name</Badge></small>
                    </div>
                    <div className="col-2">
                        <small><Badge>Verified</Badge></small>
                    </div>
                </div>
                <div className="activeUserList">
                    {rankVerified}
                </div>
            </div>
        );
    }
}

export default Ranking;